import { type FC, useMemo } from "react";

import { PlatformFilter } from "~/components/filters/PlatformFilter";
import { TypeFilterEnum } from "~/feature/dashboard/components/sortAndFilters/TypeFilterDropdown/types";
import { useFilter } from "~/providers/FilterProvider";
import { getTypeFilterValue } from "~/utils/filters/getTypeFilterValue";

// dashboard-specific: aggregated view requires at least two selected platforms
export const PlatformFilterDropdown: FC = () => {
  const { filters } = useFilter();

  const minOptionCount = useMemo(() => {
    const typeFilter = getTypeFilterValue({
      oneMarket: filters.oneMarket,
      hasDisputedMarkets: filters.hasDisputedMarkets,
      minEventCount: filters.minEventCount,
    });
    return typeFilter === TypeFilterEnum.Aggregated ? 2 : 1;
  }, [filters.hasDisputedMarkets, filters.minEventCount, filters.oneMarket]);

  return <PlatformFilter minOptionCount={minOptionCount} />;
};
